import React from 'react';
import { motion } from 'framer-motion';
import { DollarSignIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingCTA() {
  return <section id="pricing" className="py-24 px-6 relative overflow-hidden" data-id="element-93">
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-[2.5rem] shadow-warm-lg border-4 border-cream-dark" data-id="element-95">
          <div className="inline-flex items-center justify-center bg-amber/10 text-amber-dark font-bold px-4 py-2 rounded-full mb-8 uppercase tracking-wider text-sm" data-id="element-96">
            Precio especial de lanzamiento
          </div>

          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-97">
            Deja de adivinar y empieza a facturar con lo que ya tienes en tu
            cocina.
          </h2>

          <p className="text-xl text-chocolate/80 mb-10" data-id="element-98">
            El acceso inmediato al manual completo y todas las guías de costos
            tiene un valor simbólico que recuperarás con tu primera venta.
          </p>

          <div className="flex justify-center items-start mb-10" data-id="element-99">
            <DollarSignIcon className="w-8 h-8 text-terracotta mt-2" data-id="element-100" />
            <span className="text-7xl md:text-8xl font-serif font-bold text-chocolate-dark" data-id="element-101">
              6.36
            </span>
            <span className="text-2xl font-bold text-terracotta mt-auto mb-3 ml-2" data-id="element-102">
              USD
            </span>
          </div>

          <motion.div animate={{
          scale: [1, 1.02, 1]
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'easeInOut'
        }} data-id="element-103">
            <CTAButton className="w-full md:w-auto text-xl py-5 px-10" data-id="element-104" />
          </motion.div>

          <p className="mt-6 text-chocolate/60 font-medium" data-id="element-105">
            Acceso inmediato tras la confirmación de tu pago.
          </p>
        </motion.div>
      </div>
    </section>;
}